import { db } from '../FirebaseLibrary';

export const createOrganizationsReference = () => {
    return db.collection('organizations');
};

export const createOrganizationReference = (organizationId: string) => {
    return createOrganizationsReference().doc(organizationId);
};
